import React, { Component, Fragment } from 'react'
import { CollectionEditForm } from 'components'

import IconButton from '@material-ui/core/IconButton'
import DownloadIcon from '@material-ui/icons/CloudDownload'
import { authorizedLink } from 'utils'

export class SocialMediaLinksForm extends Component{

  constructor(properties) {
    super(properties)

    this.attributes =[
      {name: 'name',    label: 'Website',        required: true,
                        renderer: this.socialMediaWebsiteRenderer,
                        input: this.websiteInput},
      {name: 'linkUrl', label: 'Profile URL', required: true,
                        renderer: this.profileUrlRenderer}
    ]
  }

  socialMediaWebsiteRenderer = ({iconUrl, name}) => {
    return <img src={iconUrl} alt={name}/>
  }

  profileUrlRenderer = ({linkUrl}) => {
    return (
      <a href={linkUrl} target='_blank' rel='noopener noreferrer'>{linkUrl}</a>
    )
  }

  websiteInput = (element, form) => {
    const { socialMediaWebsites } = this.props
    const options = socialMediaWebsites.map(({name, iconUrl}) => {
      return {label: name, value: name, avatar: (<img src={iconUrl} alt={name} />)}
    })

    return (
      <form.SelectField attribute='name'
        key='website'
        label="Website"
        options={ options }/>
    )
  }

  socialMediaLinkBuilder = ({name, linkUrl}) => {
    const { socialMediaWebsites } = this.props
    const website = socialMediaWebsites.find((website) => website.name === name)

    const iconUrl =  (website) ? website.iconUrl : ''
    return {name, linkUrl, iconUrl}
  }

  logoRenderer = ({uuid, name, description, logo, logoUrls, logoFileName}) => {
    const original = (logoUrls) ? logoUrls.original : null
    let fileName = logoFileName

    if(logo) {
      fileName  = logo.name
    }
    return (
      <Fragment>
        {/** no refferer**/}
        { !uuid && !logo &&
          <a target="_blank" rel="noopener noreferrer" href={authorizedLink(original)}>
            <IconButton>
              <DownloadIcon/>
            </IconButton>
          </a>
        }
        {fileName}
      </Fragment>
    )
  }

  render = () =>
    <CollectionEditForm elements={ this.props.links } attributes={ this.attributes } onElementsChange={ this.props.onSocialMediaLinksChange }
      newElementBuilder={ this.socialMediaLinkBuilder }/>
}

export default SocialMediaLinksForm